export const events = {
    // from internal components
    onSystemEvent: 'OnSystemEvent',
    onSocketDataReceived: 'SystemSocketDataReceived',

    onTimeChanged: 'ClockVue_TimeUpdated',
    onReconnected: 'onReconnected',
    onClearCache: 'onClearCache',

    // from service
    onJournalUpdated: 'OnJournalUpdated',
    onQuotaUpdated: 'OnQuotaUpdated',
    onQuotaDeleted: 'OnQuotaDeleted',
    onTopicAdded: 'topic:added',

    // topic group events
    onTopicGroupsRecreated: 'OnTopicGroupsRecreated',

    onGroupNodesLoaded: 'OnGroupNodesLoaded', // CHANGED — was onTopicGroupChanged

    onTopicGroupSaveRequested: 'OnTopicGroupSaveRequested',
    onTopicGroupSettingsChanged: 'OnTopicGroupSettingsChanged',
    onTopicGroupCreated: 'OnTopicGroupCreated',
    onTopicGroupDeleted: 'OnTopicGroupDeleted',

    onEntriesAdded: 'OnEntriesAdded',

    // delete flow
    onNoteDeleted: 'OnNoteDeleted',

    // user settings
    onUserSettingsLoaded: 'OnUserSettingsLoaded',

    // user
    onUserLoaded: 'OnUserLoaded',
    onLogCreated: 'OnLogCreated',      // ADDED — replaces Logger_ErrorHappend

    // error handling
    onError: 'OnError',
    onMessage: 'OnMessage',
};
